import * as Components from './components';

export default function plugin(Vue) {
    Object.keys(Components).forEach(key => {
        Vue.component(key, Components[key])
    })
}


// WEBPACK FOOTER //
// ./src/form/index.js